(function () {
  "use strict";

  var t = {
    915: function _(t, e, i) {
      var a = this && this.__assign || function () {
        return (a = Object.assign || function (t) {
          for (var e, i = 1, a = arguments.length; i < a; i++) {
            for (var r in e = arguments[i]) {
              Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }
          }

          return t;
        }).apply(this, arguments);
      },
          r = this && this.__createBinding || (Object.create ? function (t, e, i, a) {
        void 0 === a && (a = i), Object.defineProperty(t, a, {
          enumerable: !0,
          get: function get() {
            return e[i];
          }
        });
      } : function (t, e, i, a) {
        void 0 === a && (a = i), t[a] = e[i];
      }),
          s = this && this.__setModuleDefault || (Object.create ? function (t, e) {
        Object.defineProperty(t, "default", {
          enumerable: !0,
          value: e
        });
      } : function (t, e) {
        t.default = e;
      }),
          o = this && this.__importStar || function (t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var i in t) {
          "default" !== i && Object.prototype.hasOwnProperty.call(t, i) && r(e, t, i);
        }
        return s(e, t), e;
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.RecordPlayingTime = void 0;

      var n = o(i(50)),
          u = function () {
        function t(t) {
          this.env = t, this.env = t, this.totalTimer = null, this.playTime = !1, this.timeInterval = [], this.videoDuration = 0, this.isStarted = !1, this.isDraged = !1, this.groupId = Date.now();
        }

        return t.prototype.initUpdateParams = function (t) {
          this.userParams = t;
        }, t.prototype.updateSpeed = function (t) {
          this.userParams = a(a({}, this.userParams), {
            speed: t
          }), this.groupId = Date.now();
        }, t.prototype.startPlayTime = function () {
          "wx" === this.getClient(this.userParams.clientId) ? this.startWxPlayTime() : this.startPcPlayTime();
        }, t.prototype.startPcPlayTime = function () {
          this.playTime = !0, this.isDraged ? (this.isDraged = !1, this.didDragged()) : (this.groupId = Date.now(), this.isStarted = !0, this.didPlayed());
        }, t.prototype.startWxPlayTime = function () {
          this.isDraged ? this.isDraged = !1 : (this.playTime = !0, this.isStarted = !0, this.groupId = Date.now(), this.didPlayed());
        }, t.prototype.stopPlayTime = function () {
          "wx" === this.getClient(this.userParams.clientId) ? this.stopWxPlayTime() : this.stopPcPlayTime();
        }, t.prototype.stopWxPlayTime = function () {
          var t = this.getPlayTimeInterval();
          this.playTime = !1, t && this.submitPlayTimeData(t, this.groupId), this.clearTimer();
        }, t.prototype.stopPcPlayTime = function () {
          this.isDraged || (this.playTime = !1, this.videoEnd());
        }, t.prototype.clearStatus = function () {
          var t = this.getPlayTimeInterval();
          t && this.submitPlayTimeData(t, this.groupId), this.timeInterval = [], this.groupId = Date.now(), this.videoDuration = 0, this.isStarted = !1, this.playTime = !1, this.isDraged = !1, this.clearTimer();
        }, t.prototype.submitPlayTimeData = function (t, e) {
          var i = a(a(a({}, t), this.userParams), {
            groupId: e,
            videoDuration: this.videoDuration
          }),
              r = this.getClient(this.userParams.clientId);
          n.default[r](i, this.env);
        }, t.prototype.getClient = function (t) {
          return n.ClientId[t];
        }, t.prototype.getPlayTimeInterval = function () {
          var t = this.timeInterval.length;

          if (t > 0) {
            var e = {
              startPoint: Math.floor(this.timeInterval[0]),
              endPoint: Math.floor(this.timeInterval[t - 1])
            };
            return this.timeInterval.length = 0, e;
          }

          return null;
        }, t.prototype.clearTimer = function () {
          clearTimeout(this.totalTimer), this.totalTimer = null;
        }, t.prototype.didDragged = function () {
          "wx" === this.getClient(this.userParams.clientId) ? this.wxDidDragged() : this.pcDidDragged();
        }, t.prototype.wxDidDragged = function () {
          var t = this.getPlayTimeInterval();

          if (this.playTime && t) {
            this.clearTimer();
            var e = t.endPoint;
            this.submitPlayTimeData(t, this.groupId), this.groupId = Date.now(), this.submitPlayTimeData({
              startPoint: e,
              endPoint: e
            }, this.groupId), this.didPlayed();
          }
        }, t.prototype.pcDidDragged = function () {
          var t = this.getPlayTimeInterval();

          if (t) {
            var e = t.endPoint;
            this.submitPlayTimeData(t, this.groupId), this.groupId = Date.now(), this.submitPlayTimeData({
              startPoint: e,
              endPoint: e
            }, this.groupId), this.didPlayed();
          }
        }, t.prototype.didPlayed = function () {
          var t = this;
          if (this.totalTimer) return null;
          this.userInterval(function () {
            var e = t.getPlayTimeInterval();
            t.playTime && e && t.submitPlayTimeData(e, t.groupId);
          }, 5e3);
        }, t.prototype.userInterval = function (t, e) {
          var i = this,
              a = function a() {
            t(), i.totalTimer = setTimeout(a, e);
          };

          this.totalTimer = setTimeout(a, e);
        }, t.prototype.videoEnd = function () {
          this.clearTimer();
          var t = this.getPlayTimeInterval();
          t && this.submitPlayTimeData(t, this.groupId);
        }, t.prototype.getStartAndEnd = function (t, e) {
          if (this.playTime) {
            var i = this.timeInterval[this.timeInterval.length - 1],
                a = this.computeDuration(i, t);

            if (this.videoDuration = Math.floor(e), this.timeInterval.push(t), this.isStarted && (this.isStarted = !1, this.submitPlayTimeData({
              startPoint: Math.floor(t),
              endPoint: Math.floor(t)
            }, this.groupId)), a > 1.5) {
              var r = this.getClient(this.userParams.clientId);
              this.isDraged = !0, "wx" === r ? this.didDragged() : this.clearTimer();
            }
          }
        }, t.prototype.computeDuration = function (t, e) {
          return Math.abs(1e6 * e - 1e6 * t) / 1e6;
        }, t;
      }();

      e.RecordPlayingTime = u;
    },
    888: function _(t, e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = {
        dev: "https://openschool-api.devp.eastedu.ltd/infrastructure_video_watch_api/video_watch_heartbeats",
        test: "https://openschool-api.test.eastedu.ltd/infrastructure_video_watch_api/video_watch_heartbeats",
        pro: "https://gateway.open-school.com.cn/infrastructure_video_watch_api/video_watch_heartbeats"
      };
    },
    50: function _(t, e, i) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.ClientId = void 0;
      var a,
          r = i(83),
          s = i(406),
          o = {
        wx: r.wxRequest,
        pc: s.pcRequest
      };
      (a = e.ClientId || (e.ClientId = {}))[a.pc = 0] = "pc", a[a.wx = 1] = "wx", e.default = o;
    },
    406: function _(t, e, i) {
      var a = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.pcRequest = void 0;
      var r = a(i(888));

      e.pcRequest = function (t, e) {
        var i = null;
        (i = window.ActiveXObject ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest()).open("POST", r.default[e], !0), i.setRequestHeader("Content-Type", "application/json"), i.send(JSON.stringify(t));
      };
    },
    83: function _(t, e, i) {
      var a = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.wxRequest = void 0;
      var r = a(i(888));

      e.wxRequest = function (t, e) {
        wx.request({
          url: r.default[e],
          data: t,
          method: "POST"
        });
      };
    }
  },
      e = {},
      i = function i(a) {
    var r = e[a];
    if (void 0 !== r) return r.exports;
    var s = e[a] = {
      exports: {}
    };
    return t[a].call(s.exports, s, s.exports, i), s.exports;
  }(915);

  module.exports = i;
})();